"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as n, forwardRef as p } from "react";
import { useSvgIcon as m } from "../useSvgIcon.js";
const s = n(
  p((C, r) => {
    const { monochrome: c, ...e } = C, t = m({
      ...e,
      ref: r
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            d: "M19.741 5.27331C19.2682 5.87031 18.664 6.35025 17.9754 6.67575C17.2868 7.00119 16.5325 7.1635 15.771 7.15C15.722 6.40425 15.822 5.65619 16.0653 4.94956C16.3085 4.24287 16.6901 3.59175 17.1877 3.03419C18.1867 1.87197 19.5977 1.14274 21.1235 1C21.2334 2.55025 20.7365 4.08256 19.7377 5.27331H19.741ZM21.1085 7.44919C18.9185 7.32331 17.0444 8.695 16.0044 8.695C14.9485 8.695 13.3577 7.5125 11.6252 7.54419C10.4964 7.57306 9.39484 7.89688 8.42997 8.48338C7.46509 9.06994 6.67053 9.89875 6.12522 10.8875C3.7619 14.9558 5.51103 20.9792 7.7919 24.2908C8.9194 25.9308 10.2577 27.7283 12.0219 27.6667C13.6885 27.6033 14.3552 26.5783 16.3694 26.5783C18.4019 26.5783 18.9844 27.6667 20.7485 27.635C22.576 27.6033 23.726 25.995 24.8444 24.355C25.6347 23.1937 26.2507 21.9231 26.6727 20.5833C25.6198 20.1228 24.723 19.3667 24.0912 18.4067C23.4593 17.4468 23.1194 16.3243 23.1127 15.175C23.1274 14.1546 23.3992 13.1543 23.9031 12.2668C24.4069 11.3792 25.1265 10.6331 25.9952 10.0975C25.4411 9.30881 24.7118 8.65919 23.8646 8.19956C23.0173 7.73994 22.0752 7.48281 21.1119 7.44831",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
s.displayName = "IconApple";
export {
  s as IconApple
};
